import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { MIGRATION_COLORS } from '../theme';

interface LegendProps {
  peoplePerDot: number;
}

function Row({ color, label }: { color: string; label: string }) {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Box
        sx={{
          width: 9,
          height: 9,
          borderRadius: '50%',
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
        {label}
      </Typography>
    </Stack>
  );
}

export default function Legend({ peoplePerDot }: LegendProps) {
  return (
    <Box>
      <Typography
        variant="overline"
        sx={{
          color: 'text.secondary',
          letterSpacing: '0.08em',
          fontWeight: 700,
          display: 'block',
          mb: 0.5,
        }}
      >
        Legend
      </Typography>

      <Stack spacing={0.75}>
        <Row color={MIGRATION_COLORS.positive} label="County gained residents (net)" />
        <Row color={MIGRATION_COLORS.negative} label="County lost residents (net)" />
        <Typography variant="caption" sx={{ color: 'text.secondary', pt: 0.25 }}>
          1 dot = {peoplePerDot.toLocaleString()} people
        </Typography>
      </Stack>
    </Box>
  );
}
